<!--
 * @Author: 史金波
 * @Date: 2021-12-15 10:06:29
 * @LastEditors: 史金波
 * @Description: 
 * @LastEditTime: 2021-12-15 11:44:41
 * @FilePath: \saas-perform-web\src\views\recharge\orderlist.vue
-->
<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
		  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
		  <el-breadcrumb-item>账户记录</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form :inline="true" :model="searchForm" class="user-search">
		  <el-form-item label="交易类型">
		    <el-select size="small" v-model="searchForm.operType" placeholder="交易类型">
		      <el-option label="全部" value=""></el-option>
		      <el-option label="核销" value="2"></el-option>
          <el-option label="退款" value="3"></el-option>
		    </el-select>
		  </el-form-item>
			<el-form-item label="">
			  <el-select size="small" v-model="searchForm.orderStatus" placeholder="状态">
				<el-option label="全部" value=""></el-option>
				<el-option label="待审核" value="1"></el-option>
				<el-option label="审核通过" value="2"></el-option>
				<el-option label="审核驳回" value="3"></el-option>
				<el-option label="充值中" value="4"></el-option>
				<el-option label="充值成功" value="5"></el-option>
				<el-option label="充值失败" value="6"></el-option>
				<el-option label="待重试" value="7"></el-option>
			  </el-select>
			</el-form-item>
		  <el-form-item>
		    <el-button size="small" type="primary" icon="el-icon-search" @click="searchOrders()">搜索</el-button>
		    <el-button size="small" type="primary" icon="el-icon-plus" @click="addRechargeOrder()">添加</el-button>
		  </el-form-item>
		</el-form>
		<el-table size="small" :data="orders" highlight-current-row v-loading="loading" border element-loading-text="加载中" style="width: 100%;">
		  <el-table-column sortable prop="id" label="交易流水号" width="200">
		  </el-table-column>
			<el-table-column sortable prop="distributorName" label="分销商名称" width="150">
			</el-table-column>
      <el-table-column sortable prop="couponId" label="卡号" width="150">
			</el-table-column>
			<el-table-column sortable prop="orderDate" label="交易时间" width="150">
			</el-table-column>
      <el-table-column sortable prop="brandName" label="品牌" width="150">
			</el-table-column>
      <el-table-column sortable prop="shopName" label="门店" width="150">
			</el-table-column>
			<el-table-column sortable prop="originAmount" label="交易金额(元)" width="150">
			</el-table-column>
			<el-table-column sortable prop="serviceAmount" label="服务费(元)" width="150">
			</el-table-column>
      <el-table-column sortable prop="closeAmount" label="结算金额(元)" width="150">
			</el-table-column>
			<el-table-column sortable prop="operTypeDesc" label="交易类型" width="150">
			</el-table-column>
		</el-table>
		<Pagination v-bind:child-msg="pageparm"  @callFather="callFather"></Pagination>
	</div>
</template>

<script>
	import Pagination from '../../components/Pagination'
	import {ordersManagerApi,searchOrdersListApi,searchDistributesApi} from "../../api/recharge/rechargeApi.js"
	export default {
		data() {
			return {
				loading: false,
				searchForm:{
					distributorName:'',
					operType:'',
					orderStatus:''
				},
				orders:[],
				pageparm: {
				  currentPage: 1,
				  pageSize: 15,
				  total: 0
				},
        distributorSelect:[]
			}
		},
		methods:{
			addRechargeOrder(){
				this.$router.push({
					path:"rechargeAdd"
				})
			},
			callFather: function(parm){
				this.pageparm.currentPage = parm.currentPage
				this.pageparm.pageSize = parm.pageSize
				this.searchOrders()
			},
			searchOrders(){
				this.loading = true;
				var searchParam = {
					distributorName: this.searchForm.distributorName,
					rechargeType: this.searchForm.orderType,
					orderStatus: this.searchForm.orderStatus,
					page: this.pageparm.currentPage,
					pageSize: this.pageparm.pageSize,
				}
				searchOrdersListApi(searchParam).then(res=>{
					console.log(res)
					this.loading=false
					this.orders = res.data.data.list
					this.pageparm.total = res.data.data.total
				})
			},
			showDetail(orderid){
				this.$router.push("rechargeDetail/" + orderid)
			}
		},
		created() {
			this.searchOrders()
      searchDistributesApi().then(res=>{
        this.distributorSelect = res.data.data
      })
		},
		components: {
		  Pagination
		},
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/recharge/orderlist.vue